export default __webpack_public_path__ + "static/media/facebook.1158c8a0.svg";